/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var TargetCrosshairIcon32Regular = forwardRef('TargetCrosshairIcon32Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 32 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3 16C3 8.82 8.82 3 16 3s13 5.82 13 13-5.82 13-13 13S3 23.18 3 16Zm2.045-1A11.003 11.003 0 0 1 15 5.045V9a1 1 0 1 0 2 0V5.045A11.003 11.003 0 0 1 26.955 15H23a1 1 0 1 0 0 2h3.955A11.003 11.003 0 0 1 17 26.955V23a1 1 0 1 0-2 0v3.955A11.003 11.003 0 0 1 5.045 17H9a1 1 0 1 0 0-2H5.045Z" })));
});
